import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Animations

function parallax(selector, trigger, level) {
    let y = level * 25;
    gsap.fromTo(selector, {
        y: -y,
    },{
	    scrollTrigger: {
            trigger: trigger,
            start: 'top center',
            end: 'bottom top',
            scrub: true,
        },
        y: y,
        duration: 1
    });
}

export default function animations() {

    let body = document.querySelector('body');
    
    // Fade in body
    gsap.to(body, {opacity:1});

    gsap.registerPlugin(ScrollTrigger);

    // Contact
    if(body.classList.contains('page-contact')) {
        gsap.to('.balloon', {
            scrollTrigger: {
                trigger: 'footer .container',
                start: 'bottom bottom',
            },
            y: -2500,
            duration: 20,
            ease: "none"
        });
        gsap.to('.balloon', {
            scrollTrigger: {
                trigger: '#balloon-container',
                start: 'top top',
            },
            x: -10,
            duration: 0.5,
            repeat: -1,
            yoyo: true,
            ease: "none"
        });
    }
}